export default __webpack_public_path__ + "static/media/ic-top.d7bc0591.svg";